import { API } from '../../api/rest';
import { FunctionComponent, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps } from 'react-router-dom';

import { Container, Section } from '../../components/Base';
import { getTitle } from '../../utils/document';

import PriceCards from './PriceCards';
import { Price } from './types';

type EnterpriseCheckoutPageProps = RouteComponentProps;

const EnterpriseCheckoutPage: FunctionComponent<
  EnterpriseCheckoutPageProps
> = ({ history, location }) => {
  const params = new URLSearchParams(location.search);
  const force = params.get('force');

  const [prices, setPrices] = useState<null | Price[]>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const queryParams = force ? { force } : undefined;

    if (force) {
      params.delete('force');
      const qs = params.toString();
      const newPath = `${location.pathname}${qs && '?' + qs}${location.hash}`;
      history.replace(newPath);
    }

    API.get({ path: '/pricing', queryParams })
      .then((_resp) => {
        const resp = _resp as { prices: Price[] };
        setPrices(resp.prices);
      })
      .catch((err) => {
        setError(String(err));
        console.error(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="premium">
      <Helmet>
        <title>{getTitle('GoFullPage Enterprise Checkout')}</title>
      </Helmet>
      <Section className="">
        <Container>
          <div className="gfp-row mb-8">
            <div className="col-8 offset-2">
              <h1 className="my-8">
                GoFullPage <span className="nowrap">Enterprise Plans</span>
              </h1>
              <p className="q mb-10">
                Sign up now for a 5-seat account, or contact us for accounts
                requiring 25 seats or more
              </p>
              <div className="mb-6">
                {error ? (
                  <div className="rounded-lg bg-red-200 p-6 text-red-600">
                    Error: {error}
                  </div>
                ) : prices ? (
                  <PriceCards prices={prices} />
                ) : (
                  <div>Loading…</div>
                )}
              </div>
            </div>
          </div>
        </Container>
      </Section>
    </div>
  );
};

EnterpriseCheckoutPage.displayName = 'EnterpriseCheckoutPage';

export default EnterpriseCheckoutPage;
